// store/ui.ts
import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', {
  state: () => ({
    qrScannerActive: false,
  }),
  actions: {
    openQrScanner() {
      this.qrScannerActive = true
    },
    closeQrScanner() {
      this.qrScannerActive = false
    },
  },
})
